import { render, staticRenderFns } from "./tvs_basic.vue?vue&type=template&id=7a857f36&scoped=true"
import script from "./tvs_basic.vue?vue&type=script&lang=js"
export * from "./tvs_basic.vue?vue&type=script&lang=js"
import style0 from "./tvs_basic.vue?vue&type=style&index=0&id=7a857f36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a857f36",
  null
  
)

export default component.exports